import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Behind the Scenes of Controla’s Cyber Risk Model",
  header: "Behind the Scenes of Controla’s Cyber Risk Model",
  date: "2025-11-13",
  description:
    "How Controla uses Bayesian networks, probability distributions, and Monte Carlo simulations to turn complex cyber risk into clear financial numbers.",
  category: "security",
  draft: false,
  authorKey: "niklas_volcz",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
